import './bootstrap'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import mainStore from './store'
import {VueTables, ServerTable, ClientTable, Event} from 'vue-tables-2';
import VueToastr from '@deveodk/vue-toastr'
import {Pagination} from 'vue-pagination-2';
import Peity from 'vue-peity'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import VueSignaturePad from 'vue-signature-pad';
import money from 'v-money'

const translation = {
    count: 'Mostrando {from} de {to} até {count} de registros',
    filter: 'Pesquisar:',
    filterPlaceholder: 'Pesquisar',
    limit: 'Registros:',
    noResults: 'Nenhum registro encontrado',
    page: 'Página:',
    // for dropdown pagination filterBy: 'Filter by {column}',
    // Placeholder for search fields when filtering by column loading:'Loading...',
    // First request to server defaultOption:'Select {column}'
    // default option for list filters }
}

const options = {
    requestFunction: function (data) {
        // data.token = this.$store.getters.token
        return axios.get(this.url, {
            params: data
        }).catch(function (e) {
            this.dispatch('error', e);
            router.push('/login')
        }.bind(this));
    },
    texts: translation,
    pagination: {chunk: 15, dropdown: false, nav: 'scroll'},
    perPage: 10,
    perPageValues: [10, 25, 50, 100]
}

const VueInputMask = require('vue-inputmask').default

Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(router)
Vue.use(ServerTable, options, true, 'bootstrap3', 'footerPagination')
Vue.use(VueToastr)
Vue.use(VueInputMask)
Vue.use(Peity)
Vue.use(VueSignaturePad);
Vue.use(money, {precision: 4})

Vue.component('peity', Peity)
Vue.component('vue-ctk-date-time-picker', VueCtkDateTimePicker);

export const store = new Vuex.Store(mainStore);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>',
    created() {
        this.$store.dispatch('initialize')
    },
});

/*
  <link rel="stylesheet" href="src/assets/auxiliary/bootstrap/css/bootstrap.min.css">
    <link rel="stylesheet" href="src/assets/css/style.css">
    <link rel="stylesheet" href="src/assets/auxiliary/animate/animate.css">
    <link rel="stylesheet" href="src/assets/auxiliary/fontawesome/css/all.min.css">
*/

window.$ = window.jQuery = require('jquery');
require('bootstrap');

window.moment = require('moment');
moment.locale('pt-br');

import './assets/auxiliary/bootstrap/css/bootstrap.min.css'
import './assets/css/style.css'
import './assets/auxiliary/animate/animate.css'
import './assets/auxiliary/fontawesome/css/all.min.css'
import '../node_modules/@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import swal from 'sweetalert'

//Fullcalendar css
import '../node_modules/@fullcalendar/core/main.css';
import '../node_modules/@fullcalendar/daygrid/main.css';

//Datetimepicker css
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';


Vue.prototype.$http = window.axios;
Vue.prototype.$message = function (title, msg, type) {

    let newMsg = '';
    if(msg instanceof Object){

        newMsg += "<ul>";
        for (var key in msg) {
            if (msg.hasOwnProperty(key)) {
                newMsg += "<li>";
                newMsg += msg[key];
                newMsg += "</li>";
            }
        }
        newMsg += "</ul>";

    } else newMsg = msg;

    this.$toastr('add',
        {
            title: title,
            msg: newMsg,
            clickClose: true,
            timeout: 4000,
            position: 'toast-top-right',
            type: type
        })
};


//Vue instance dedicated to events (eventbus)
const EventBus = new Vue();
export default EventBus;

axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && parseInt(error.response.status) === 401 && error.response.data != 'Credenciais Inválidas') {
            localStorage.clear();
            router.push({path: '/login'});
        } else {
            return Promise.reject(error);
        }
    }
)


// WEBPACK FOOTER //
// ./src/main.js